import { html, slotted } from "@microsoft/fast-element";
/**
 * Generates a template for the Button component.
 *
 * @public
 */
export function filterPillTemplate() {
    return html `
    <template
      tabindex="${(x) => (x.disabled ? -1 : 0)}"
      appearance="${(x) => x.appearance}"
      shape="${(x) => x.shape}"
      size="${(x) => x.size}"
      icon-only="${(x) => x.iconOnly}"
      aria-label="${(x) => x.ariaLabel}"
      ?pressed="${(x) => x.pressed}"
      ?disabled="${(x) => x.disabled}"
    >
      <slot name="start"></slot>
      <span class="content" part="content">
        <slot ${slotted("defaultSlottedContent")}></slot>
      </span>
      <slot name="end"></slot>
    </template>
  `;
}
/**
 * The template for the Button component.
 *
 * @public
 */
export const template = filterPillTemplate();
//# sourceMappingURL=filter-pill.template.js.map